<template>
    <div id="bene-home-phone-container" :class="showFormInput.contact.homeNo ? '' : ' hide' ">
        <f7-list class="form-group">
            <f7-list-input
                id           ="homeNoListId"
                input-id     ="homeNo"
                name         ="homeNo"
                type         ="tel"
                class        ="mobile-input"

                v-if         ="showFormInput.contact.homeNo"
                :label       ="$t('beneficiary-home-no-optional')"
                placeholder  =""
                :value       ="homeNo"
                @change      ="setHomeNo($event.target.value); validateInput($event.target); setInput($event.target);"

                autocomplete ="off"
                maxlength    ="15"
                outline
                floating-label
                clear-button
            >
                <f7-link id="beneHomeCountryCode" popover-open=".popover-home-no" slot="content-start" class="flag-with-chevron">
                    <img :src="getFlagImg(homeIDD)" class="" loading="lazy"/>
                    <span class="">{{ homeIDDCode }}</span>
                </f7-link>
            </f7-list-input>
        </f7-list>

        <BeneficiaryHomePhonePopover />
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    // import BeneficiaryHomePhonePopover from '../components/beneficiary-home-phone-popover.vue';
    export default {
        props: {
        },
        mounted() {
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'homeNo',
                'homeIDD',
                'homeIDDCode',
                'countryCodeList',
            ])
        },
        components: {
            BeneficiaryHomePhonePopover: () => import('../components/beneficiary-home-phone-popover.vue')
        },
        methods: {
            ...mapActions('beneficiary', [
                'setHomeNo',
            ]),

            validateInput(inputEl){
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl){
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>